module.exports = __webpack_public_path__ + "static/img/success.11b0a64e.svg";